import { Link, useOutletContext } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { PROFILE_STEPS, getFirstIncompleteStep, stepRoute } from 'pages/Profile/helper';
import Card from './Card';
import { getCompletedCount, getMinutesLeft, getStepCards, treatmentConsentsCard } from './helper';

const Dashboard = () => {
  const { completion, sectionData }: any = useOutletContext();

  const nextStep = getFirstIncompleteStep(completion);
  const completed = getCompletedCount(completion);
  const minutesLeft = getMinutesLeft(completion);
  const total = PROFILE_STEPS.length;

  return (
    <div className="flex-1 overflow-y-auto p-6 lg:p-8">
      <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-5 mb-6">
        <div className="max-w-xl">
          <h1 className="text-xl sm:text-2xl font-bold text-secondary-900 leading-tight">Your forms</h1>
          <p className="mt-1 text-sm text-secondary-400">
            Everything we need on file, grouped into short sections. Finish them before your visit and check-in takes seconds.
          </p>
        </div>

        <div className="w-full shrink-0 rounded-2xl border border-gray-100 bg-secondary-50/50 p-4 lg:w-80">
          <div className="flex items-center justify-between gap-3">
            <p className="text-sm font-semibold text-secondary-800">{completed} of {total} forms complete</p>
            {minutesLeft > 0 && <p className="shrink-0 text-xs text-secondary-400">About {minutesLeft} min left</p>}
          </div>

          <div className="mt-3 h-1.5 w-full rounded-full bg-gray-200 overflow-hidden">
            <div
              className="h-full rounded-full bg-green-500 transition-all duration-500"
              style={{ width: `${(completed / total) * 100}%` }}
            />
          </div>

          {completed < total && (
            <Link
              to={stepRoute(nextStep)}
              className="btn mt-4 h-11 min-h-0 w-full flex-nowrap gap-2 rounded-xl border-none bg-secondary-900 font-semibold text-white hover:bg-black"
            >
              <span className="min-w-0 truncate">Continue: {nextStep.title}</span>
              <ArrowRight size={16} strokeWidth={2.5} className="shrink-0" />
            </Link>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4">
        {getStepCards(sectionData, completion).map((card) => <Card key={card.key} {...card} />)}

        {sectionData?.treatmentConsents?.length > 0 && <Card {...treatmentConsentsCard(sectionData)} />}
      </div>
    </div>
  );
};

export default Dashboard;
